module.exports = __webpack_public_path__ + "media/images/portal/i-6-79eccf542572255d17272e751a11e9df.png";